<template>
    <div class="animated fadeIn container-fluid">
        
        <h3>感測器參數範本編輯器</h3>
        
        <div>

            <div>
                <div class="block-sm">分類</div>
                <div class="block-sm">

                    <b-form-radio-group v-model="selected_type" :plain="true" buttons>
                        <template v-for="(_deviceType, idx_dt) in admin_DeviceType_List">
                            <b-form-radio v-if="chekDeviceType(_deviceType.type)" :key="idx_dt"
                                            :value="_deviceType.type" :button-variant="'outline-' + _deviceType.variant">
                                <i :class="$tools.style.classIcon(_deviceType.type, 'block-text')"></i>{{ $t('n.' + _deviceType.type) }} {{ _deviceType.type }}
                            </b-form-radio>
                        </template>
                    </b-form-radio-group>

                </div>
            </div>
            <div>
                <div class="block-sm">版本</div>
                <div class="block-sm">

                    <b-form-radio-group v-model="selected_version" :plain="true" buttons>
                        <b-form-radio v-for="(_ps_Option, key, idx_pso) in paramSets_Options[ selected_type ]" :key="idx_pso" :value="key" :button-variant="'outline-dark'">
                            {{ key }}
                        </b-form-radio>
                    </b-form-radio-group>

                </div>
            </div>

            <div v-if="selected_version">

                <b-form-radio v-for="(_set, idx_set) in paramSets_Options[ selected_type ][ selected_version ]" :key="idx_set" :value="_set" v-model="selected_set"
                                    class="param-select block-text-sm" :button-variant="'outline-dark'">
                    <div class="param-set clickable">
                        <span v-if="_set.id != 'new'" class="set-id">ID : {{ _set.id }}</span>
                        <span v-else class="set-id-new">Create New <i class="fa fa-plus"></i></span>
                        <span class="set-name">{{ _set.name }}</span>
                    </div>
                </b-form-radio>

            </div>
                            
            <br>

            <b-card v-if="edit_selected">
                <div class="device param-set">
                    <h3 class="block-text">
                        <span v-if="edit_selected.id != 'new'" class="set-id">ID : {{ edit_selected.id }}</span>
                        <span v-else class="set-id-new">Create New <i class="fa fa-plus"></i></span>
                        <span class="set-name">{{ $t('n.' + edit_selected.type) }} {{ edit_selected.type }} - {{ edit_selected.version }}</span>
                    </h3>

                    <b-row>
                        <b-col md="8">
                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-pencil"></i>{{ $t('menu.name') }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model.trim="edit_selected.name" size="lg"
                                                :maxlength="$tools.input.getInputMaxLength('device','nickname')" />
                            </b-input-group>
                        </b-col>
                        <b-col md="8">
                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-menu"></i>Note</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-textarea type="text" v-model.trim="edit_selected.note" :rows="2" :max-rows="6" size="lg"></b-form-textarea>
                            </b-input-group>
                        </b-col>
                    </b-row>

                    <br>
                    
                    <div>
                        <h3 class="err-msg">*** 注意：此處勾選的順序會影響儀表板參數的呈現順序喔!! ***</h3>
                        <div class="block-sm">
                            Sensor Parameters：
                            <code>{{ edit_selected.sensor_params }}</code>
                        </div>
                        <br>
                        <div class="device-sensor">
                            <div v-for="(ds, idx_ds) in edit_selected.sensor_params" :key="idx_ds" class="device-sensor-blocks">
                                {{ $t('sensor.' + ds) }}<div class="device-unit" v-html="$t('sensor.u_' + ds)"></div>
                            </div>
                        </div>
                        <div class="list-sensor-area">
                            <b-form-group>
                                <b-form-checkbox-group v-model="edit_selected.sensor_params" >
                                    <b-form-checkbox v-for="(param, idx_pa) in admin_SensorParams_List" :key="idx_pa"
                                                    class="list-sensor-item"
                                                    :value="param.value">
                                        {{ param.value }} {{ param.name }}
                                    </b-form-checkbox>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </div>
                    </div>

                    <div>
                        <div class="block-sm">
                            Visualization：
                            <b-button size="sm" variant="outline-warning" class="block-text" @click="cloneParameters(edit_selected)">同上</b-button>
                            <code>{{ edit_selected.visualization }}</code>
                        </div>
                        <br>
                        <div class="device-sensor">
                            <div v-for="(dv, idx_dv) in edit_selected.visualization" :key="idx_dv" class="device-sensor-blocks">
                                {{ $t('sensor.' + dv) }}<div class="device-unit" v-html="$t('sensor.u_' + dv)"></div>
                            </div>
                        </div>
                        <div class="list-sensor-area">
                            <b-form-group>
                                <b-form-checkbox-group v-model="edit_selected.visualization" >
                                    <b-form-checkbox v-for="(param, idx_pa) in admin_SensorParams_List" :key="idx_pa"
                                                    class="list-sensor-item"
                                                    :value="param.value">
                                        {{ param.value }} {{ param.name }}
                                    </b-form-checkbox>
                                </b-form-checkbox-group>
                            </b-form-group>
                        </div>
                    </div>

                </div>
            </b-card>
                    

        </div>
        
            
        <div class="text-center" v-if="edit_selected">
            <b-button variant="dark" class="px-4 btn-upload"
                        v-if="is_create == false"
                        @click="deleteParamSet(edit_selected)" :disabled="uploading" >
                <i class="fa fa-minus"></i>{{ $t('menu.delete') }}
            </b-button>

            <b-button v-if="is_create" variant="success" class="px-4 btn-upload" @click="createParamSet(edit_selected)" :disabled="uploading || checkDisabled" >
                {{ $t('menu.upload') }}
            </b-button>
            <template v-else>
                <b-button variant="success" class="px-4 btn-upload" @click="updateParamSet(edit_selected)" :disabled="uploading || checkDisabled" >
                    {{ $t('menu.save_changes') }}
                </b-button>
            </template>
        </div>
        <div class="proj-toolbox-area" v-if="edit_selected && edit_selected.id != 'new'">
            <h4>感測器參數範本 - 複製工具</h4>
            <div class="text-muted">同 server 複製用</div>
            <br>
            <b-row>
                <b-col md="6">
                    <div class="block-md">
                        Type：
                        <div class="block-text">
                            <b-form-select v-model="clone_type">
                                <template v-for="(_deviceType, idx_dt) in admin_DeviceType_List">
                                    <option  v-if="chekDeviceType(_deviceType.type)" :key="idx_dt" :value="_deviceType.type">
                                        <i :class="$tools.style.classIcon(_deviceType.type, 'block-text')"></i>{{ $t('n.' + _deviceType.type) }} {{ _deviceType.type }}
                                    </option>
                                </template>
                            </b-form-select>
                        </div>
                    </div>
                    <div v-if="clone_type != undefined" class="block-md">
                        Version：
                        <div class="block-text">
                            <b-form-select v-model="clone_version">
                                <option v-for="(_ps_Option, key, idx_pso) in paramSets_Options[ clone_type ]" :key="idx_pso" :value="key">
                                    {{ key }}
                                </option>
                            </b-form-select>
                        </div>
                    </div>
                </b-col>
                <b-col md="3">
            
                    <div class="text-center">

                        <b-button v-if="is_create == false" variant="success" class="px-4 btn-upload" @click="createParamSet(edit_selected, true)" :disabled="uploading || checkDisabled" >
                            {{ $t('menu.clone') }}
                        </b-button>

                    </div>

                </b-col>
            </b-row>

        </div>
        <div class="proj-toolbox-area" v-if="edit_selected && edit_selected.id != 'new'">
            <b-row align-v="center">
                <b-col md=8>
                    <h4>感測器參數範本 - json 文字格式複製工具</h4>
                    <div class="text-muted">不同 server 之間複製用</div>
                    <div>
                        {{ $tools.data.show_jsonString( edit_selected ) }}
                    </div>
                </b-col>
                <b-col md=4>
                    <BtnCopyToClipboard :copy_content="JSON.stringify( edit_selected )" :btn_text="'複製 json'" btn_style="big"></BtnCopyToClipboard>
                </b-col>
            </b-row>
        </div>
        <div class="proj-toolbox-area" v-if="edit_selected && edit_selected.id == 'new'">
            <h4>感測器參數範本 - json 文字格式複製工具</h4>
            <div class="text-muted">不同 server 之間複製用</div>
            <br>
            <b-row align-v="center">
                <b-col md=8>
                    <b-form-textarea v-model="copy_json" placeholder="貼上 json 文字"
                                     rows="6" >
                    </b-form-textarea>
                </b-col>
                <b-col md=4>
                    <b-button variant="warning" class="px-4 btn-upload" @click="copyParamSet" :disabled="uploading || checkDisabled_copy" >
                        將 json 文字內容填入建立中的範本
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <br>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import SaltMap from '@/common/salt-map'
import BtnCopyToClipboard from '@/views/components/Button_CopyToClipboard'

export default {
    components: {
        BtnCopyToClipboard,
    },
    data () {
        return {
            
            // paramSets: [
            //     {
            //         id: 1,
            //         name: 'WB',
            //         type: 'weatherbox',
            //         version: 'WB',
            //         sensor_params: ['air_temperature', 'rainfalls'],
            //         visualization: ['air_temperature'],
            //         note: '氣象站',
            //     },
            //     {
            //         id: 2,
            //         name: '三合一設定',
            //         type: 'wand',
            //         version: 'DA',
            //         sensor_params: ['soil_temperature', 'soil_moisture', 'soil_conductivity', 'voltage', 'rssi', 'snr'],
            //         visualization: ['soil_temperature', 'soil_moisture', 'soil_conductivity', 'voltage'],
            //         note: 'DA 三合一',
            //     },
            //     {
            //         id: 3,
            //         name: '三合一設定',
            //         type: 'wand',
            //         version: 'DB',
            //         sensor_params: ['soil_temperature', 'soil_moisture', 'soil_conductivity', 'voltage', 'rssi', 'snr'],
            //         visualization: ['soil_temperature', 'soil_moisture', 'soil_conductivity', 'voltage'],
            //         note: 'DB 三合一',
            //     },
            //     {
            //         id: 4,
            //         name: 'PH 設定',
            //         type: 'wand',
            //         version: 'DB',
            //         sensor_params: ['soil_temperature', 'soil_ph', 'voltage', 'rssi', 'snr'],
            //         visualization: ['soil_temperature', 'soil_ph', 'voltage'],
            //         note: 'DB PH',
            //     },
            //     {
            //         id: 5,
            //         name: 'PH 設定',
            //         type: 'wand',
            //         version: 'DB',
            //         sensor_params: ['soil_temperature', 'soil_ph', 'voltage', 'rssi', 'snr'],
            //         visualization: ['soil_temperature', 'soil_ph', 'voltage'],
            //         note: 'DB PH',
            //     },
            //     {
            //         id: 6,
            //         name: 'PH 設定',
            //         type: 'wand',
            //         version: 'DB',
            //         sensor_params: ['soil_temperature', 'soil_ph', 'voltage', 'rssi', 'snr'],
            //         visualization: ['soil_temperature', 'soil_ph', 'voltage'],
            //         note: 'DB PH',
            //     },
            // ],

            uploading: false,
            is_create: true,
            paramSets_Options: {},
            selected_type: undefined,
            selected_version: undefined,
            selected_set: undefined,
            edit_selected: undefined,
            clone_type: undefined,
            clone_version: undefined,
            copy_json: ''
        }
    },
    mounted ()
    {
        this.getParamSets();
    },
    computed: {
        ...mapState({
            'admin_DeviceType_List': state => state.device.list_deviceTypes,
            'admin_SensorParams_List': state => state.device.list_sensorParams,
        }),


        checkDisabled ()
        {
            if (this.edit_selected == undefined)      return true;
            if (this.edit_selected.name == '')        return true;
            if (this.edit_selected.name == undefined) return true;
            if (this.edit_selected.sensor_params.length == 0) return true;
            return false;
        },

        checkDisabled_clone ()
        {
            if (this.clone_type == undefined)    return true;
            if (this.clone_version == undefined) return true;
            return false;
        },

        checkDisabled_copy ()
        {
            if (this.copy_json == undefined) return true;
            if (this.copy_json == '')        return true;
            return false;
        },

    },
    watch: {

        selected_type: function (val, oldVal)
        {
            if (val)
            {
                if (this.deviceHashid)
                {
                    this.selected_version = this.deviceHashid.slice(0,2)
                }
                else this.selected_version = 'all'
            }
        },

        selected_version: function (val, oldVal)
        {
            let _version_option = this.paramSets_Options[ this.selected_type ]
            if (val)
            {
                if ( _version_option[ val ] && _version_option[ val ].length > 0 )
                {
                    this.selected_set = this.paramSets_Options[ this.selected_type ][ val ][0]
                }
                else { this.selected_set = undefined }
            }
            else { this.selected_set = undefined }
        },

        selected_set: function (val, oldVal)
        {
            if (val && val.id == 'new')
            {
                this.is_create = true
                val.name = ''
                val.note = ''
                val.sensor_params = []
                val.visualization = []
            }
            else
            {
                this.is_create = false
            }

            this.copy_json = ''
            this.cloneEditSet(val)
        },

    },
    methods: {

        copyParamSet ()
        {
            let _copyObj = JSON.parse( this.copy_json )
            if (_copyObj)
            {
                if ( _copyObj.name != undefined ) this.edit_selected.name = _copyObj.name;
                if ( _copyObj.note != undefined ) this.edit_selected.note = _copyObj.note;
                if ( _copyObj.type != undefined ) this.edit_selected.type = _copyObj.type;
                if ( _copyObj.version != undefined )        this.edit_selected.version = _copyObj.version;
                if ( _copyObj.sensor_params != undefined )  this.edit_selected.sensor_params = _copyObj.sensor_params;
                if ( _copyObj.visualization != undefined )  this.edit_selected.visualization = _copyObj.visualization;
            }
        },

        cloneEditSet (set)
        {
            // 複製一份來編輯，避免改到原檔
            if (set)
            {
                this.edit_selected = {
                    id:      set.id,
                    name:    set.name,
                    note:    set.note,
                    type:    set.type,
                    version: set.version,
                    sensor_params: set.sensor_params,
                    visualization: set.visualization,
                }
            }
            else this.edit_selected = undefined
        },

        cloneParameters (set)
        {
            set.visualization = set.sensor_params.slice();
        },

        chekDeviceType (type)
        {
            switch (type)
            {
                case 'camera':  return false;
                default:        return true;
            }
        },

        // GET：取得所有 ParamSets
        getParamSets ()
        {
            this.uploading = true;
            this.selected_set = undefined;
            this.edit_selected = undefined;
            
            const settings = {}
            this.$store.dispatch('device/getDevice_ParamSets', settings)
            .then( res => {
                this.uploading = false;
                this.arrangeParamSets( res.paramset )
            })
            .catch( err => {
                this.uploading = false;
                this.arrangeParamSets()
            })
        },
        // POST：建新的 ParamSet
        createParamSet (set, clone = false)
        {
            this.uploading = true;
            
            const options = {
                method:'POST',
                url: this.$config.getAPI_URL('Admin_ParamSets'),
                data: {
                    name:    set.name + ( clone ? ' clone' : '' ),
                    note:    set.note,
                    type:    ( clone ? this.clone_type : set.type ),
                    version: ( clone ? this.clone_version : set.version ),
                    sensor_params: JSON.stringify( set.sensor_params ),
                    visualization: JSON.stringify( set.visualization ),
                }
            }
            this.$http(options)
            .then( res => {
                this.uploading = false;
                this.$toastr.s( this.$t('other.update_succeeded'), 'ParamSet Created: ' + set.id + ' - ' + set.name );
                
                this.getParamSets();
            })
            .catch( err => {
                this.uploading = false;
                this.$toastr.e( this.$t('other.update_failed') + '<br>' + err,  'ParamSet Created: ' + set.id + ' - ' + set.name );
            })
        },
        // PUT：更新 ParamSet
        updateParamSet (set)
        {
            this.uploading = true;
            
            const options = {
                method:'PUT',
                url: this.$config.getAPI_URL('Admin_ParamSets_Edit', { setID: set.id }),
                data: {
                    name:    set.name,
                    note:    set.note,
                    type:    set.type,
                    version: set.version,
                    sensor_params: JSON.stringify( set.sensor_params ),
                    visualization: JSON.stringify( set.visualization ),
                }
            }
            this.$http(options)
            .then( res => {
                this.uploading = false;
                this.$toastr.s( this.$t('other.update_succeeded'), 'ParamSet Updated: ' + set.id + ' - ' + set.name );
                
                this.getParamSets();
            })
            .catch( err => {
                this.uploading = false;
                this.$toastr.e( this.$t('other.update_failed') + '<br>' + err,  'ParamSet Updated: ' + set.id + ' - ' + set.name );
            })
        },
        // DELETE：刪除 ParamSet
        deleteParamSet (set)
        {
            this.uploading = true;
            
            const options = {
                method:'DELETE',
                url: this.$config.getAPI_URL('Admin_ParamSets_Edit', { setID: set.id }),
            }
            this.$http(options)
            .then( res => {
                this.uploading = false;
                this.$toastr.s( this.$t('other.update_succeeded'), this.$t('menu.delete') + ' ParamSet: ' + set.id + ' - ' + set.name );
                
                this.getParamSets();
            })
            .catch( err => {
                this.uploading = false;
                this.$toastr.e( this.$t('other.update_failed') + '<br>' + err, this.$t('menu.delete') + ' ParamSet: ' + set.id + ' - ' + set.name );
            })
        },

        arrangeParamSets (list = [])
        {
            // initialize
            let _options = {}
            this.admin_DeviceType_List.forEach( _typeSetting => {
                _options[ _typeSetting.type ] = {}

                // 根據 SaltMap 加鹽表裡設定的 version 來建立範本按鈕 
                let _versions = SaltMap.device[ _typeSetting.type ].options
                for (let _ver in _versions)
                {
                    _options[ _typeSetting.type ][ _ver ] = [
                        {
                            id: 'new',
                            name: '',
                            type: _typeSetting.type,
                            version: _ver,
                            sensor_params: [],
                            visualization: [],
                            note: '',
                        }
                    ]
                }
            })

            // arrange paramSets to options
            list.forEach( _set => {
                
                if ( _options[ _set.type ][ _set.version ] == undefined ) _options[ _set.type ][ _set.version ] = []

                _options[ _set.type ][ _set.version ].push( _set )
            })
            this.paramSets_Options = _options
        },

    }
}
</script>

<style lang="scss" scoped>

.list-sensor-area
{
    padding: 5px;
    margin-bottom: 10px;
    font-size: 0.92rem;
    color: #7a8787;
}
.list-sensor-item
{
    display: inline-block;
    min-width: 270px;
}

</style>
